
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    export class MFGTransactionItemsDialog extends _Ext.MFGTransItemEditorDialog<MFGTransactionItemsRow> {
        protected getFormKey() { return MFGTransactionItemsForm.formKey; }
        protected getLocalTextPrefix() { return MFGTransactionItemsRow.localTextPrefix; }
        protected getNameProperty() { return MFGTransactionItemsRow.nameProperty; }
        protected get_ExtDialogOptions() {
            let opt = super.get_ExtDialogOptions();
            opt.AutoFitContentArea = false;
            return opt;
        }
        public departmentid: number;
        public form = new MFGTransactionItemsForm(this.idPrefix);
        constructor() {
            super();
            q.hideCategorylinks(this.element);
            q.SetCategoryEightColumn(this.form.BagNo);
            q.initMFGBOMEditor(this, this.form.BOMDetails);
            //q.SetCategoryThreeColumn(this.form.ProductCode);
            q.SetCategoryFullWidth(this.form.FromDeptId);
            q.SetCategoryFullWidth(this.form.ToPieces);
            q.SetCategoryFullWidth(this.form.BOMDetails);
            q.SetCategoryFullWidth(this.form.LossDetails);
            q.SetCategoryFourColumn(this.form.ProductItemImage);
            q.hideEditorCategoryLabel(this.form.ProductItemImage.element);
            q.hideEditorCategoryLabel(this.form.BagNo.element);
            q.hideImageToolbar(this.form.ProductItemImage);
            q.hideEditorLabel(this.form.ProductItemImage);
            q.setTextRightAlign(this.form.FromDiamondPieces);
            q.setTextRightAlign(this.form.FromDiamondWeight);
            q.setTextRightAlign(this.form.FromOtherPieces);
            q.setTextRightAlign(this.form.FromOtherWeight);
            q.setTextRightAlign(this.form.FromStonePieces);
            q.setTextRightAlign(this.form.FromStoneWeight);
            q.setTextRightAlign(this.form.FromWeight);
            q.setTextRightAlign(this.form.FromNetWeight);
            q.setTextRightAlign(this.form.ToDiamondPieces);
            q.setTextRightAlign(this.form.ToDiamondWeight);
            q.setTextRightAlign(this.form.ToOtherPieces);
            q.setTextRightAlign(this.form.ToOtherWeight);
            q.setTextRightAlign(this.form.ToStonePieces);
            q.setTextRightAlign(this.form.ToStoneWeight);
            q.setTextRightAlign(this.form.ToWeight);
            q.setTextRightAlign(this.form.ToNetWeight);

            q.setTextRightAlign(this.form.LossPercent);
            q.setTextRightAlign(this.form.Loss);
            q.setTextRightAlign(this.form.FromPieces);;

            q.hideEditorLabel(this.form.BOMDetails);
            q.hideEditorLabel(this.form.LossDetails);
            q.hideEditorLabel(this.form.Button);


            var fieldEditor: JQuery = this.form.BagNo.element.closest(".editor");
            fieldEditor.addClass("has-inplace-button");
            $(' <button type="button">...</button>')
                .addClass('inplace-button')
                .addClass('inplace-search edit')
                .attr('title', 'Search')
                .insertAfter(fieldEditor)
                .click((e) => { this.inplaceSearchClick(e) }
                );

            this.form.BagNo.changeSelect2(e => {

                this.form.BOMDetails.cleardata();
                Q.reloadLookup(WorkOrderItemsRow.lookupKey);
                Q.reloadLookup(WIPTransactionRow.lookupKey);
                let workorderdetails: WIPMovementRow;

                WIPMovementSelectService.List({ BagNo: this.form.BagNo.value }, response => workorderdetails = response.Entities[0], { async: false });

                let bomdetails: WIPTransactionRow[];
                WIPTransactionService.MFGBOMList({ BagNo: this.form.BagNo.value }, response => bomdetails = response.Entities, { async: false });

                this.form.FromDeptId.value = workorderdetails.DepartmentId.toString();
                this.form.FromWorkerId.value = workorderdetails.EmployeeId.toString();

                this.form.FromPieces.value = workorderdetails.Pieces;
                this.form.FromDiamondPieces.value = workorderdetails.DiamondPieces;
                this.form.FromDiamondWeight.value = workorderdetails.DiamondWeight;
                this.form.FromOtherPieces.value = workorderdetails.OtherPieces;
                this.form.FromOtherWeight.value = workorderdetails.OtherWeight;
                this.form.FromStonePieces.value = workorderdetails.StonePieces;
                this.form.FromStoneWeight.value = workorderdetails.StoneWeight;
                this.form.FromWeight.value = workorderdetails.Weight;
                this.form.FromNetWeight.value = workorderdetails.Weight;
                this.form.ProductId.value = workorderdetails.ProductId.toString();
                this.form.Line_No.value = workorderdetails.Line_No.toString();
                //this.form.LotNo.value = workorderdetails.LotNo;
                this.form.AttributeId.value = workorderdetails.AttributeId.toString();
                this.form.ProductCode.value = workorderdetails.ProductCode;
                this.form.Attribute.value = workorderdetails.Attribute;
                //this.form.TransDate.value = workorderdetails.TransDate;
                this.form.VoucherNo.value = workorderdetails.VoucherNo;
                this.form.Purity.value = workorderdetails.Purity;
                this.form.PureWeight.value = workorderdetails.PureWeight;
                this.form.CompanyId.value = Q.Authorization.userDefinition.CompanyId;
                this.form.FinancialYearId.value = Q.Authorization.userDefinition.FinancialYearId;
                this.form.RefTransId.value = workorderdetails.TransId.toString();
                this.form.RefTransItemId.value = workorderdetails.TransItemId.toString();
                this.form.RefVoucherId.value = workorderdetails.RefVoucherId;
                this.form.OrderTypeId.value = workorderdetails.RefVoucherId;
                this.form.OrderTransId.value = workorderdetails.TransId;
                this.form.OrderTransItemId.value = workorderdetails.TransItemId;
                this.form.ToPieces.value = workorderdetails.Pieces;
                this.entity.MetalColorId = workorderdetails.MetalColorId;
                this.entity.KaratId = workorderdetails.KaratId;
                this.entity.MetalId = workorderdetails.MetalId;
                //this.form.UserId.value = workorderdetails.UserId;

                this.setImage(workorderdetails.ImageName);
                var maxdeptno = 0;
                for (var k = 0; k < bomdetails.length; k++) {
                    var deptno = bomdetails[k].DepartmentId;
                    maxdeptno = deptno;
                }
                //bomdetails = bomdetails.filter(x => x.DepartmentId == maxdeptno);




                //var PrdDetails = OMS.ProductMasterRow.getLookup().itemById[workorderdetails.ProductId];

                var newbomdetails = [];
                for (var i = 0; i < bomdetails.length; i++) {
                    var value = bomdetails[i];

                    var newbom: MFGTransactionBOMRow = {
                        AttributeId: value.AttributeId,
                        ItemTypeId: value.ItemTypeId,
                        CalcOnId: value.CalcOnId,
                        ProductCode: value.ProductCode,
                        Attribute: value.Attribute,
                        BomProductId: value.ProductId,
                        BagNo: value.BagNo,
                        LotNo: value.LotNo == undefined ? "" : value.LotNo,

                        ProductId: workorderdetails.ProductId,
                        FromDeptId: value.DepartmentId,
                        FromWorkerId: value.EmployeeId,
                        Pieces: value.Pieces,
                        Line_No: value.Line_No,
                        PureWeight: value.PureWeight,
                        Purity: value.Purity,
                        Weight: value.Weight,
                        RefTransId: value.TransId,
                        RefVoucherId: value.VoucherTypeId,
                        IsCustomerItem: value.IsCustomerItem
                    };
                    newbomdetails.push(newbom);
                    this.form.FromWorkerId.value = newbom.FromWorkerId.toString();
                }
                this.form.BOMDetails.setdata(newbomdetails);
                this.CalculateTotals();

            });

            this.form.ToWeight.changeSelect2(e => {
                if (this.form.ToWeight.value < this.form.FromWeight.value) {
                    var bomdetails = this.form.BOMDetails.getItems()
                    var self = this;
                    for (var k of bomdetails) {
                        if (k.ItemTypeId == 104 && k.CategoryId != 7) {

                            if (k.ProductTypeId == self.entity.MetalId && k.MetalColorId == self.entity.MetalColorId && k.KaratId == self.entity.KaratId) {

                                let ProductProcessLoss: OMS.ProductSequenceRow[];

                                OMS.ProductSequenceService.GetProductSequece({
                                    ProductId: Q.parseInteger(this.form.ProductId.value),
                                    ProcessId: Q.parseInteger(this.form.FromProcessId.value),
                                    DepartmentId: Q.parseInteger(this.form.FromDeptId.value)
                                },
                                    response => response.Entities = ProductProcessLoss,
                                    { async: false }
                                );

                                var loss = (this.form.FromWeight.value - this.form.ToWeight.value);
                                var lossper = (loss / this.form.FromWeight.value) * 100;
                                if (ProductProcessLoss != null) {
                                    if (lossper > ProductProcessLoss[0].MaxLoss) {
                                        q.alert("Not Allowed", "Process Loss is more than allowed Loss", false);
                                        this.form.ToWeight.value = this.form.FromWeight.value;
                                    }
                                    else {
                                        this.form.Loss.value = loss;
                                        this.form.LossPercent.value = (loss / k.Weight) * 100;
                                        k.Weight = k.Weight - loss;

                                        this.form.LossDetails.cleardata();
                                        this.form.LossDetails.setdata(k, loss);
                                        if ((this.form.FromNetWeight.value - loss) < 0) {
                                            Q.alert('Invalid Weight');
                                        } else
                                            this.form.ToNetWeight.value = this.form.FromNetWeight.value - loss;
                                    }
                                }
                                else {
                                    this.form.Loss.value = loss;
                                    this.form.LossPercent.value = (loss / k.Weight) * 100;
                                    k.Weight = k.Weight - loss;

                                    this.form.LossDetails.cleardata();
                                    this.form.LossDetails.setdata(k, loss);
                                    if ((this.form.FromNetWeight.value - loss) < 0) {
                                        Q.alert('Invalid Weight');
                                    } else
                                        this.form.ToNetWeight.value = this.form.FromNetWeight.value - loss;
                                }
                            }
                        }
                    }
                    this.form.BOMDetails.cleardata();
                    if (this.form.ToWeight.value != this.form.FromWeight.value)
                        this.form.BOMDetails.setdata(bomdetails);
                } else if (this.form.ToWeight.value > this.form.FromWeight.value) {
                    this.form.ToWeight.value = 0;
                } else if (this.form.ToWeight.value == this.form.FromWeight.value) {
                    //this.form.LossDetails.cleardata();
                    //this.form.Loss.value = null;
                    var self = this;
                    this.form.BOMDetails.getItems().forEach(function (item) {
                        if (item.ItemTypeId == 104) {
                            if (self.form.LossDetails.getItems().length > 0) {
                                let loss = self.form.LossDetails.getItems().filter(x => x.BomProductId == item.BomProductId)[0];
                                if (loss != undefined || loss != null) {
                                    item.Weight = item.Weight + loss.Weight;
                                }

                                //item.Weight = self.form.FromWeight.value - self.form.FromStoneWeight.value - (self.form.FromDiamondWeight.value / 5);
                                item.PureWeight = item.Weight * item.Purity;
                                var id = self.form.BOMDetails.getId(item);
                                self.form.BOMDetails.view.updateItem(id, item);
                            }

                        }

                    });
                    this.form.LossDetails.cleardata();
                    this.form.Loss.value = null;

                }
            });

            this.form.ToWorkerId.changeSelect2(e => {
                if (this.form.FromWorkerId.value == this.form.ToWorkerId.value) {
                    Q.alert('Workers cannot match');
                    this.form.ToWorkerId.value = "0";
                    return;
                }
            });

            this.form.ToDeptId.changeSelect2(e => {
                this.form.ToProcessId.WorkshopId = Q.parseInteger(this.form.ToDeptId.value);
                this.form.ToProcessId.updateItems();
                q.showAndSetRequiredField(this.form.ToProcessId);
                q.showAndSetRequiredField(this.form.ToWorkerId);

            });
            this.form.Button.onClick = (e) => {
                this._QCEditorClick(e);
            };


        }

        public CalculateTotals() {
            if (!this.isReadOnly) {
                var Pcs = 0, Wt = 0, othrpcs = 0, othrwt = 0, clrpcs = 0, clrwt = 0, diapcs = 0, diawt = 0, grswt = 0, cts = 0, gms = 0, rate = 0;
                for (var k of this.form.BOMDetails.getItems()) {

                    if (k.ItemTypeId == 104) {
                        Wt += k.Weight;
                    }
                    if (k.ItemTypeId == 105 && k.CalcOnId == 5) {
                        cts += k.Weight;
                        diapcs += k.Pieces
                    }
                    if (k.ItemTypeId == 105 && k.CalcOnId == 4) {
                        gms += k.Weight;
                        clrpcs += k.Pieces;
                    }

                    //rate += k.BomAmount;

                }
                //this.form.FromNetWeight.value = Wt;
                //this.form.FromOtherPieces.value = othrpcs || 0;
                //this.form.FromStonePieces.value = clrpcs || 0;
                //this.form.FromStoneWeight.value = gms;
                //this.form.FromDiamondPieces.value = diapcs || 0;
                //this.form.FromDiamondWeight.value = cts || 0;
                //this.form.FromOtherWeight.value = 0;
                this.form.ToNetWeight.value = Wt;
                this.form.ToOtherPieces.value = othrpcs || 0;
                this.form.ToStonePieces.value = clrpcs || 0;
                this.form.ToStoneWeight.value = gms;
                this.form.ToDiamondPieces.value = diapcs || 0;
                this.form.ToDiamondWeight.value = cts || 0;
                this.form.ToOtherWeight.value = 0;

                //if (cts > 0)
                //    this.form.FromWeight.value = Wt + gms + (cts / 5);
                //else
                //    this.form.FromWeight.value = Wt + gms;


                if (Wt > 0)
                    q.showAndSetRequiredField(this.form.ToWeight);
                else {
                    q.showAndDisableField(this.form.ToWeight);
                    this.form.ToWeight.value = this.form.FromWeight.value;
                }
            }
            else {
                q.showAndDisableField(this.form.ToWeight);
            }
        }

        protected inplaceSearchClick(e: any): void {
            if (!this.isViewMode()) {
                if (this.form.BOMDetails.getItems().length == 0) {
                    var grid = WIPMovementSelectGrid;

                    var filters: _Ext.SelectGridFilters = {
                        PartyId: 0
                    }

                    var pickerDialog = new _Ext.GridItemPickerDialog({
                        gridType: grid, multiple: false, title: "Select Work Order", GridFilters: filters
                    });

                    pickerDialog.onSuccess = (selectedItems: WIPMovementRow[]) => {
                        let Item = selectedItems.shift();
                        if (Item != null) {

                            this.form.BagNo.value = Item.BagNo;
                            this.form.FromPieces.value = Item.Pieces;
                            this.form.FromDiamondPieces.value = Item.DiamondPieces;
                            this.form.FromDiamondWeight.value = Item.DiamondWeight;
                            this.form.FromOtherPieces.value = Item.OtherPieces;
                            this.form.FromOtherWeight.value = Item.OtherWeight;
                            this.form.FromStonePieces.value = Item.StonePieces;
                            this.form.FromStoneWeight.value = Item.StoneWeight;
                            this.form.FromWeight.value = Item.Weight;
                            this.form.FromNetWeight.value = Item.NetWeight;
                            this.form.FromDeptId.value = Item.DepartmentId.toString();
                            this.form.FromWorkerId.value = Item.EmployeeId.toString();
                            this.form.ProductId.value = Item.ProductId.toString();
                            this.form.Line_No.value = Item.Line_No.toString();
                            this.entity.MetalColorId = Item.MetalColorId;
                            this.entity.KaratId = Item.KaratId;
                            this.entity.MetalId = Item.MetalId;
                            //this.form.LotNo.value = Item.Lo;

                            this.form.AttributeId.value = Item.AttributeId.toString();
                            this.form.ProductCode.value = Item.ProductCode;
                            //this.form.TransDate.value = Item.TransDate;
                            this.form.VoucherNo.value = Item.VoucherNo;
                            this.form.Purity.value = Item.Purity;
                            this.form.PureWeight.value = Item.PureWeight;
                            this.form.CompanyId.value = Item.CompanyId;
                            this.form.FinancialYearId.value = Item.FinancialYearId;
                            this.form.RefTransId.value = Item.TransId.toString();
                            this.form.RefTransItemId.value = Item.TransItemId.toString();
                            this.form.RefVoucherId.value = Item.VoucherTypeId;
                            this.form.OrderTypeId.value = Item.OrderTypeId;
                            this.form.OrderTransId.value = Item.OrderId;
                            this.form.OrderTransItemId.value = Item.TransItemId;
                            this.form.ToPieces.value = Item.Pieces;
                            this.form.Parts.value = Item.Parts;
                            this.form.SubBagNo.value = Item.SubBagNo;
                            this.form.FromProcessId.value = Item.ProcessId.toString();
                            this.form.TreeId.value = Item.TreeId == null ? "0" : Item.TreeId.toString();
                            this.form.TreeItemId.value = Item.TreeItemId == null ? "0" : Item.TreeItemId.toString();
                            this.form.TreeNo.value = Item.TreeNo;
                            this.setImage(Item.ImageName);

                            let bomdetails: WIPTransactionRow[];
                            WIPTransactionService.MFGBOMList({ BagNo: this.form.BagNo.value }, response => bomdetails = response.Entities, { async: false });
                            var newbomdetails = [];
                            for (var i = 0; i < bomdetails.length; i++) {
                                var value = bomdetails[i];

                                var newbom: MFGTransactionBOMRow = {
                                    AttributeId: value.AttributeId,
                                    ItemTypeId: value.ItemTypeId,
                                    CalcOnId: value.CalcOnId,
                                    ProductCode: value.ProductCode,
                                    Attribute: value.Attribute,
                                    BomProductId: value.ProductId,
                                    BagNo: value.BagNo,
                                    ProductId: value.ProductId,
                                    FromDeptId: value.DepartmentId,
                                    FromWorkerId: value.EmployeeId,
                                    Pieces: value.Pieces,
                                    Line_No: value.Line_No,
                                    PureWeight: value.PureWeight,
                                    Purity: value.Purity == null ? 0 : value.Purity,
                                    Weight: value.Weight,
                                    RefTransId: value.TransId,
                                    RefVoucherId: value.VoucherTypeId,
                                    SettingId: value.SettingId,
                                    Lab: value.Lab,
                                    StoneStatusId: value.StoneStatusId,
                                    CertificateNo: value.CertificateNo,
                                    LotNo: value.LotNo == undefined ? "" : value.LotNo,
                                    CategoryId: value.CategoryId,
                                    ProductTypeId: value.ProductTypeId,
                                    KaratId: value.KaratId,
                                    MetalColorId: value.MetalColorId
                                };
                                newbomdetails.push(newbom);

                            }
                            this.form.BOMDetails.setdata(newbomdetails);
                            this.form.ToDeptId.element.focus();
                            this.CalculateTotals();
                        }
                    }
                    pickerDialog.dialogOpen();
                }
                else
                    q.Alert("Not Allowed", "Party can not be changed while items are added", 2000, false);
            }
            else
                q.Alert("View Mode", "Can not make changes in view mode", 2000, false);
        }

        protected _QCEditorClick(e: any): void {
            if (!this.isViewMode()) {
                var allqcvalues = [];
                var getitemqcvalues = this.form.QualityInspection.getItems();
                if (getitemqcvalues.length > 0) {
                    allqcvalues = getitemqcvalues
                } else {

                    var fromprocessid = parseInt(this.form.FromProcessId.value);

                    let processqcvalues;
                    if (fromprocessid > 0) {
                        OMS.ProcessInspectionService.GetProcessQCList({ ProcessId: fromprocessid }
                            , response => { processqcvalues = response.Entities }
                            , { async: false });
                    }
                    let productqcvalues;
                    OMS.ProductInspectionService.GetProductQCList({ ProcessId: fromprocessid, ProductId: parseInt(this.form.ProductId.value) }
                        , response => {
                            productqcvalues = response.Entities
                        }
                        , { async: false });
                    if (processqcvalues != undefined) {
                        for (var i = 0; i < processqcvalues.length; i++) {
                            allqcvalues.push(processqcvalues[i]);
                        }
                    }
                    if (productqcvalues != undefined) {

                        for (var i = 0; i < productqcvalues.length; i++) {
                            allqcvalues.push(productqcvalues[i]);
                        }
                    }
                }
                var options = { QCValues: allqcvalues }
                var dialog = new Common.ProcessQIDialog(options);
                dialog.dialogOpen();

                dialog.element.bind('dialogclose', () => {

                    var isclosed = dialog.checksuccess;
                    if (isclosed) {
                        var qclist = dialog.qclist;
                        var validateallqc = true;
                        this.form.QualityInspection.setData(qclist);
                        for (var i = 0; i < qclist.length; i++) {
                            if (qclist[i].Status == false || qclist[i].Status == undefined)
                                validateallqc = false
                        }
                        if (validateallqc) {
                            this.form.QualityInspectionValue.value = "1";
                            q.showAndSetRequiredField(this.form.ToDeptId);
                        }
                        else {
                            this.form.QualityInspectionValue.value = "0";
                            this.form.ToDeptId.value = this.form.FromDeptId.value;
                            q.readonlyEditor(this.form.ToDeptId.element, true);
                            this.form.ToProcessId.WorkshopId = Q.parseInteger(this.form.ToDeptId.value);
                            this.form.ToProcessId.updateItems();
                            q.showAndSetRequiredField(this.form.ToProcessId);
                            q.showAndSetRequiredField(this.form.ToWorkerId);
                        }


                    }
                });
            }
            else
                q.Alert("View Mode", "Can not make changes in view mode", 2000, false);
        }
        protected afterLoadEntity() {
            super.afterLoadEntity();
            q.showAndDisableField(this.form.ToProcessId);
            q.showAndDisableField(this.form.ToWorkerId);

            let Items: any[];

            if (!isNaN(this.entity.TransId)) {
                WIPMovementService.RefList({
                    RefVoucherId: this.entity.VoucherTypeId,
                    RefTransId: this.entity.TransId,
                    RefTransItemId: this.entity.TransItemId
                },
                    response => Items = response.Entities,
                    { async: false }
                );

                if (Items.length > 0) {
                    this.setReadOnly(true);
                    this.dialogTitle = this.dialogTitle + ' : ReadOnly';
                    var fieldEditor: JQuery = this.element.find(".inplace-button");
                    fieldEditor.attr('disabled', 'disabled');
                }
            }

            if (this.isReadOnly) {
                this.setReadOnly(true);
            }


        }
        protected validateBeforeSave() {
            super.validateBeforeSave();
            var todeptid = parseInt(this.form.ToDeptId.value);
            var toworkerid = parseInt(this.form.ToWorkerId.value);
            var fromdeptid = parseInt(this.form.FromDeptId.value);
            var fromworkerid = parseInt(this.form.FromWorkerId.value);
            var bomdetails = this.form.BOMDetails.getItems();
            for (var a = 1; a < bomdetails.length; a++) {
                bomdetails[a].FromDeptId = fromdeptid;
                bomdetails[a].FromWorkerId = fromworkerid;
                bomdetails[a].ToDeptId = todeptid;
                bomdetails[a].ToWorkerId = toworkerid;
            }
            var lossdetails = this.form.LossDetails.getItems();
            for (var b = 1; b < lossdetails.length; b++) {
                lossdetails[b].FromDeptId = fromdeptid;
                lossdetails[b].FromWorkerId = fromworkerid;
                lossdetails[b].ToDeptId = todeptid;
                lossdetails[b].ToWorkerId = toworkerid;
            }
            this.form.BOMDetails.setdata(bomdetails);
            this.form.LossDetails.setdatawithvalues(lossdetails);
            return true;
        }
        protected onDialogOpen() {
            super.onDialogOpen();

        }

        public setImage(image: any) {
            var x: Serenity.UploadedFile = {
                Filename: image,
                OriginalName: ""
            }
            this.form.ProductItemImage.value = x;
        }
    }
}